import React, {useEffect} from 'react'
import styled from "styled-components";

function Question({ element, question = {}, onOptionSelected = () => {} }) {
  const [selectedAnswer, setSelectedAnswer] = React.useState();  
  const handleResponse = (a) => {
    setSelectedAnswer(a);
    onOptionSelected(element, question, a);
  };

  useEffect(()=>{
    setSelectedAnswer();
  }, [element])

  return (
    <div className={"question_container"}>
      <TextQuestion>{question.question.replace("&amp;", "&")}</TextQuestion>
      <AnswerContainer>
        {question.answers &&
          question.answers.map((a) => {
            let highlight_selected = "";
            let highlight_correct;

            var isTheCorrect;
            var isTheSelected;
            if (selectedAnswer && selectedAnswer.caption === a.caption) {
              isTheSelected = selectedAnswer.isCorrect === true;
            } else {
              if (selectedAnswer) {
                isTheCorrect = a.isCorrect;
              }
            }
            return (
              <Answer
                className={`answer ${selectedAnswer ? 'disabled' : ''}`}
                isTheSelected={isTheSelected}
                isTheCorrect={isTheCorrect}
                key={a.caption}
                onClick={() => {
                  handleResponse(a);
                }}
              >
                {a.caption.replace("&amp;", "&")}
              </Answer>
            );
          })}
      </AnswerContainer>
    </div>
  );
}
export default Question;

const TextQuestion = styled.div`
  color: white;
  font-size: 16px;
  font-family: 'Poppins';
  line-height: 18px;
  margin: 0 5% 20px;
`;

const AnswerContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 20px;
`;

const Answer = styled.div`
  background-color: transparent;
  color: #78a1bb;
  cursor: pointer;
  text-align: left;
  width: 100%;
  display: inline-block; 
  font-size: 16px; 
  font-family: 'Poppins';
  padding: 1em 1.4em;
  -webkit-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
  border: 2px solid #78a1bb;
  margin: 2.5%;

  &.disabled{
    pointer-events: none;
    curson: default;
  }

  ${({ isTheSelected, isTheCorrect }) =>
    isTheSelected === undefined &&
    isTheCorrect === undefined &&
    `
    &:hover {
      background-color: rgba(120, 161, 187, 0.25);
    }
`}

  ${({ isTheSelected }) =>
    isTheSelected &&
    `
    color: azure;
    background-color: #63c13266;
  `}

  ${({ isTheCorrect }) =>
    isTheCorrect &&
    `
    color: azure;
    background-color: #ff000063;
  `}
`;
